import { Controller } from "@hotwired/stimulus"

export default class ClsController extends Controller {
  static targets = ["apology"]

  connect() {
    this.shifted = false
  }

  shift() {
    if (this.shifted) return
    this.shifted = true
    this.apologyTarget.style.display = "block"
  }
}
